import { render, staticRenderFns } from "./DataDetails.vue?vue&type=template&id=da630184&scoped=true"
import script from "./DataDetails.vue?vue&type=script&lang=js"
export * from "./DataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da630184",
  null
  
)

export default component.exports